<template>
    <div class="row mb-3">
        <div class="col-12 col-md-8 d-inline-flex">
            <img class="mr-2" src="~@/assets/images/doc.svg" alt="Document" />
            <div class="standard">
                <div class="name">{{ standard.Name }} <br /></div>
                <div
                class="title"
                v-html="standard.StandardIntroduction"
                ></div>
            </div>
        </div>
        <div class="col-6 col-md-2 date">{{ status }}</div>
        <div class="col-6 col-md-2">
            <a role="navigation" class="view float-right" @click="routeToStandard()" @keydown.enter="routeToStandard()"  tabindex="0"
                >Review<i class="angle-right-green"></i>
            </a>
        </div>
    </div>
</template>

<script>
import { privateRouter } from '../router';

    export default {
        name: 'OverviewSavedAssessmentsStandard',
        data() {
            return {
                status: ''
            };
        },
        props: {
            standard: {
                type: Object,
                default: () => {}
            },
            satId: {
                type: Number,
                default: () => 0
            }
        },
        created() {
            this.standardCompletionStatus();
        },
        methods: {
            routeToStandard(){
                privateRouter.push({
                    name: 'AssessmentStandard',
                    query: {
                        satId: this.satId,
                        standardId: this.standard.Id
                    }
                });
            },
            standardCompletionStatus() {
                let questions = [];              
                this.standard.Sections.forEach(section => {
                    questions = questions.concat(section.Questions);
                });

                this.status = '';
                let positiveCount = 0;
                let partialCount = 0;

                questions.forEach(question => {
                    if(question.SAT_SavedResponses.PositiveResponse == true) {
                        positiveCount++;
                    } else if(question.SAT_SavedResponses.PartialResponse == true) {
                        partialCount++;
                    }
                });

                if(positiveCount == questions.length) { // only all Positive means 'fully met'
                    this.status = 'Fully met'; 
                } else if(positiveCount > 0 || partialCount > 0) { // any Postive or Partial means 'Partially met'
                    this.status = 'Partially met';
                } else { // all negative, NotApplicable or not answered means 'not met'
                    this.status = 'Not met';
                }
            },  
        }
    }
</script>

<style lang="sass" scoped>

</style>